import React from "react";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-294" data-mp="3mf7qmi3rtqck">
      <div className="mx-auto max-w-6xl" data-id="element-295" data-mp="3r80qarkdu8hs">
        <SectionHeading eyebrow="What colleagues are saying" title="Physiotherapists Who Brought Structure to Their Assessments" data-id="element-296" data-mp="3r8trld0ko5sj" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-297" data-mp="42t1l7y7olmx">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-paper p-6 sm:p-8" data-id="element-298" data-mp="925plw0tjyr3">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-299" data-mp="e0z67xbek5vh">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-[#F59E0B] text-[#F59E0B]" aria-hidden="true" data-id="element-300" data-mp="2auando501q9q" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-lg leading-relaxed text-ink" data-id="element-301" data-mp="2fu6tbsx9brrx">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-302" data-mp="1smdq7tsqaxqm">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-303" data-mp="1nshuyz3unoz5" />
                <div data-id="element-304" data-mp="1erbdontdma4u">
                  <p className="font-display text-lg font-extrabold text-ink" data-id="element-305" data-mp="2bjx1z56kmugq">{t.name}</p>
                  <p className="text-sm font-medium text-muted" data-id="element-306" data-mp="26kk4zrlzk70f">
                    {t.role} · {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="I Want the Same Clarity" data-id="element-307" data-mp="1xkfagi1w533o" />
      </div>
    </section>;
}